import { LocationContacts } from '@hakimo-ui/hakimo/feature-shared';

interface Props {
  locationId: number;
  locationAlarmId: string;
  locationTenantId?: string;
}

export function LocationContactsWrapper(props: Props) {
  const { locationId, locationAlarmId, locationTenantId } = props;

  return (
    <div className="space-y-1">
      <h2 className="flex h-9 items-center pl-1 font-bold">
        Location Contacts
      </h2>
      <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 overflow-hidden rounded-md p-2">
        <LocationContacts
          locationId={locationId}
          locationAlarmId={locationAlarmId}
          locationTenantId={locationTenantId}
          showTitle={false}
        />
      </div>
    </div>
  );
}

export default LocationContactsWrapper;
